import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { visitsApi } from '../../api/lib/visits';
import { visitLogsKeys } from '../../api/query-keys/visit-logs';
import { VisitLog } from '../../api/types/visits';

export const useVisitLogs = (id: number) => {
  return useQuery<VisitLog[], ApiError>({
    queryKey: visitLogsKeys.list(id),
    queryFn: () => visitsApi.fetchVisitLogs(id),
  });
};
